import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import {
  AuthSelectors,
  GlobalSelectors,
  SiteActions,
  SiteSelectors,
} from '@app/store';
import { Store } from '@ngrx/store';

import { AppState } from '@app/store/app.state';
import { SiteDetailsModel } from '@app/core/models/site.model';
import { CP_PERMISSIONS } from '@app/shared/app.constants';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html',
  styleUrls: ['./site-detail.component.scss'],
})
export class SiteDetailComponent implements OnInit, OnDestroy {
  currentSite$: Observable<SiteDetailsModel> = this.store.select(
    SiteSelectors.getCurrentSite
  );

  isCurrentSiteLoading$: Observable<boolean> = this.store.select(
    SiteSelectors.isCurrentSiteLoading
  );

  isCurrentServiceSchedulesLoading$: Observable<boolean> = this.store.select(
    SiteSelectors.isCurrentServiceSchedulesLoading
  );

  // handles all component subscriptions
  subscriptions: Subscription = new Subscription();

  backButtonUrl = '/organization/sites';

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const { customerId, siteId } = this.activatedRoute.snapshot.params;

    if (!siteId) {
      // eslint-disable-next-line no-console
      console.error('Site Id is missing.');
      return;
    }

    this.store.dispatch(SiteActions.currentServiceSchedulesStartLoading());
    this.store.dispatch(SiteActions.getServiceScheduleDetails({ siteId }));

    this.subscriptions.add(
      this.store
        .select(AuthSelectors.getUserPermissions)
        .pipe(
          map((userPermissions: string[]) => {
            const isPermission = userPermissions.includes(
              CP_PERMISSIONS.HAULERCONTRACT_READ
            );
            return isPermission;
          })
        )
        .subscribe(isPermission => {
          if (isPermission)
            this.store.dispatch(
              SiteActions.getSiteHaulerContractDocuments({ siteId })
            );
        })
    );

    if (!customerId) {
      // eslint-disable-next-line no-console
      console.error('Customer Id is missing.');
      return;
    }

    this.store.dispatch(SiteActions.currentSiteStartLoading());
    this.store.dispatch(SiteActions.getSite({ customerId, siteId }));

    this.subscriptions.add(
      this.store
        .select(GlobalSelectors.getPreviousURL)
        .subscribe(previousUrl => (this.backButtonUrl = previousUrl))
    );
  }
  ngOnDestroy() {
    // reset site details and weights. prevents page from showing old site details while new site loading
    this.store.dispatch(SiteActions.resetSiteDetails());
    this.subscriptions.unsubscribe();
  }
}
